import React from 'react';
import { Typography, IconButton } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Tooltip from '@src/components/Tooltip';
import { StyledPackageInfoAPIRow } from './index.style';

const PackageInfoAPIRow = ({
  label,
  value,
  showTooltip = false,
  tooltipContent,
  isBold = false,
  isMobile = false,
  onTooltipClick,
}) => (
  <StyledPackageInfoAPIRow>
    <div className="row-content">
      <Typography
        className="label"
        sx={{
          lineHeight: isMobile ? '16px' : '20px',
          maxWidth: isMobile ? '50%' : 'auto',
        }}
      >
        {label}
      </Typography>
      <div className="value-container">
        <Typography className="value" sx={{ fontWeight: isBold ? 700 : 400 }}>
          {value}
        </Typography>
        {showTooltip && tooltipContent && (
          <Tooltip title={tooltipContent} arrow placement="top">
            <IconButton
              onClick={onTooltipClick}
              size="small"
              sx={{ padding: 0 }}
            >
              <InfoOutlinedIcon className="tooltip-icon" />
            </IconButton>
          </Tooltip>
        )}
      </div>
    </div>
  </StyledPackageInfoAPIRow>
);

export default PackageInfoAPIRow;
